import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';

import { useGlobalProps } from 'providers/global-props';
import { default as Attach } from '.';

const LazyItem = (props) => {
    // console.log(props);
    const
        { MAPI } = useGlobalProps(),
        { style, thumb } = props,
        [isSpacer, setIsSpacer] = useState(true),
        [isLoading, setIsLoading] = useState(true),
        // Error state for this case: https://jira.dev.inbox.lv/browse/MAIL-4195
        [isError, setIsError] = useState(false),
        imgRef = useRef(null),
        // Request thumbs sized according to the current breakpoint config
        src = `${MAPI.baseUrl + thumb}?height=${style.height}&width=${style.width}`;

    function checkSpacer({ naturalHeight, naturalWidth }) {
        setIsLoading(false);
        if (naturalHeight > 1 || naturalWidth > 1) {
            setIsSpacer(false);
        }
    }

    useLayoutEffect(() => {
        const { current: img } = imgRef;
        if (!img) { return; }

        function imgLoaded() {
            checkSpacer(this);
        }

        function imgError() {
            setIsError(true);
            setIsLoading(false);
        }

        img.addEventListener('error', imgError);
        img.addEventListener('load', imgLoaded);

        return () => {
            img.removeEventListener('load', imgLoaded);
            img.removeEventListener('error', imgError);
        };
    },[imgRef]);

    return (
        <Attach
            isImage={isSpacer ? null : true}
            hasError={isSpacer || null}
            itemData={props}
        >
            { isLoading && <Loader className='item-loader' size='medium' /> }
            { !isError && <img height={style.height} width={style.width} ref={imgRef} src={src} /> }
        </Attach>
    );
};

LazyItem.propTypes = {
    baseUrl: PropTypes.string,
    name: PropTypes.string,
    style: PropTypes.object,
    thumb: PropTypes.string,
    wrapper: PropTypes.func
};

export default LazyItem;